import styled from 'styled-components';
import {  MagstimColor } from "common";

const styledMagstimAppWrapper = styled.div`

margin: 0;
padding: 0;

/* global brand styles and colours */

color: ${ MagstimColor.MagstimWhite};
background:  ${props => props.mainBackground};

a {
      color: ${ MagstimColor.MagstimWhite};
      &:hover {
        color: ${ MagstimColor.MagstimPrimaryBlue};
      }
}

label {
  color: ${ MagstimColor.MagstimWhite};
  font-weight: 600;
}

input, .ui-droptext {
  background-color: ${ MagstimColor.MagstimTextBackground};
  border-color: ${ MagstimColor.MagstimTextBackground};
  color: ${ MagstimColor.MagstimWhite};

  &:focus {
    color: ${ MagstimColor.MagstimWhite};
    background-color: ${ MagstimColor.MagstimTextBackground};
    border-color: ${ MagstimColor.MagstimTextBackground};
  }

  &:disabled {
    color: ${ MagstimColor.MagstimGrey153};
    background-color: ${ MagstimColor.MagstimGroupBackground};
    border: 2px solid ${ MagstimColor.MagstimTextBackground};
    box-shadow: none;
  }
}

textarea, textarea.form-control {
  background-color: ${ MagstimColor.MagstimTextBackground};
  border-color: ${ MagstimColor.MagstimTextBackground};
  color: ${ MagstimColor.MagstimWhite};
  border-radius: 0px;
}

.btn {
  border-radius: 4px;
}

.btn-primary {
  background-color: ${ MagstimColor.MagstimPrimaryButton};
  border-color: ${ MagstimColor.MagstimPrimaryButton};

  &:hover {
    background-color: ${ MagstimColor.MagstimPrimaryButton};
    border-color: ${ MagstimColor.MagstimPrimaryButton};
  }
  &:active {
    /* background-color: darken(${ MagstimColor.MagstimPrimaryButton}, 10%) !important; */
    /* border-color: darken(${ MagstimColor.MagstimPrimaryButton}, 10%)  !important; */
    background-color: #007BBC !important;
  }
  &:disabled {
    background-color: ${ MagstimColor.MagstimPrimaryButton};
    border-color: ${ MagstimColor.MagstimPrimaryButton};
    opacity: 0.3
  }
}


.ui-fillh {
  /* height: 100vh; */
  height: 100%;
  }
.ui-header {
      .col {
          padding-left: 0;
          padding-right: 0;
      }
}
  .ui-main {
  overflow: hidden;
  }

  .ui-bg {
  background-color: ${ MagstimColor.MagstimGroupBackground};
}

.ui-bg-no-row-margin{
  .row {
      margin-left: 0px;
      margin-right: 0px;
  } 
}

.ui-panel {
  background-color: ${ MagstimColor.MagstimTextBackground};
}


.ui-scroll, .table-scroll {
  /* scrollbar show only when more content to see */
  overflow: auto !important;
}
.ui-scroll::-webkit-scrollbar, .table-scroll::-webkit-scrollbar {
  width:20px; /* scrollbar width */
}
.ui-scroll::-webkit-scrollbar-track, .table-scroll::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); /* scrollbar track */
  border-radius: 0
}
.ui-scroll::-webkit-scrollbar-thumb, .table-scroll::-webkit-scrollbar-thumb {
  background-color: ${ MagstimColor.MagstimPrimaryBlue}; /* scrollbar thumb background color */
  border-radius: 0;
}	

.breadcrumb-item{

  @media only screen and (max-width: 600px) {
    font-size:16px;
  }

  @media only screen and (min-width: 1200px) {
    font-size:18px;
  }

}

/*
https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/date

https://stackoverflow.com/questions/62162645/change-color-of-chromes-calendar-icon-in-html-date-input
This feels wrong, but is the only way I can find to change the color of that icon!
(this question was asked on StackOverflow 4 months ago and has been viewed 3k times, and nobody has offered a better solution)
*/
input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(1);
}


/*
#MAGS-1764 - PDM - Text Input fields broken on iOS mobile
https://stackoverflow.com/questions/32851413/input-field-ios-safari-bug-cant-type-in-any-text
*/

input { 
  -webkit-user-select:text;
}

textarea  { 
  -webkit-user-select:text;
}

`
export default styledMagstimAppWrapper;